import React from 'react';
import ReactMarkdown from 'react-markdown';
import FormattedResponse from './FormattedResponse';

const MessageList = ({
  chatMessages,
  isGeneratingPerformanceSummary,
  firstAssistantMessage,
  hasEnoughMessages,
  showFirstMessageModal,
  onShowFirstMessage,
  messagesEndRef
}) => {
  return (
    <>
      {chatMessages.map((msg, idx) => (
        <div key={idx} className={`message ${msg.sender}`}>
        {msg.sender === "system" ? (
           <FormattedResponse response={msg.message} />
        ) : (
            <div className="message-bubble">
              <ReactMarkdown>{msg.message}</ReactMarkdown>
            </div>
        )}
        </div>
      ))}

      {isGeneratingPerformanceSummary && (
        <div className="message system">
          <div className="message-bubble performance-generating">
            <div className="performance-generating-spinner" aria-label="Loading spinner" />
            <span>Generating performance summary...</span>
          </div>
        </div>
      )}

      {/* Show button only if first message exists*/}
      {firstAssistantMessage && hasEnoughMessages && !showFirstMessageModal && (
        <button
          className="show-first-message-btn"
          onClick={onShowFirstMessage}
          title="Show First Message"
        >
          Show First Message
        </button>
      )}

      <div ref={messagesEndRef} />
    </>
  );
};

export default MessageList;
